/**
 * @generated SignedSource<<7e9619e405944468a3ee27ceafe1cea5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type YourProfile_user$data = {
  readonly panelist: {
    readonly globalCharacteristics: ReadonlyArray<{
      readonly key: string | null;
      readonly response: string | null;
    }>;
  } | null;
  readonly " $fragmentType": "YourProfile_user";
};
export type YourProfile_user$key = {
  readonly " $data"?: YourProfile_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"YourProfile_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "YourProfile_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PanelistNode",
      "kind": "LinkedField",
      "name": "panelist",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GlobalCharacteristic",
          "kind": "LinkedField",
          "name": "globalCharacteristics",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "response",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserNode",
  "abstractKey": null
};

(node as any).hash = "9a905d39d1e31ee00f328c37980f8948";

export default node;
